import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { navigate } from '../../helpers/history';
import Logger from '../../services/Logger';
import { isHaveTeammatePermission } from '../../store/helpers/user';
import showNoManageTeamPermissionsDialog from './showNoManageTeamPermissionsDialog';

export default function useOpenColorLabelSettings(loggerEvent) {
  const user = useSelector((state) => state.user);
  const teammates = useSelector((state) => state.teammates?.items) || [];
  const roles = useSelector((state) => state.roles?.items) || [];

  return useCallback(() => {
    const hasManageTeamPermission = isHaveTeammatePermission('manageTeam', user);

    Logger.log('User', loggerEvent, { hasManageTeamPermission });

    if (!hasManageTeamPermission) {
      showNoManageTeamPermissionsDialog({ user, teammates, roles });
      return;
    }

    navigate('/teammates?tab=color-labels');
  }, [loggerEvent, roles, teammates, user]);
}
